function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2104 24.7012H16.2905L15.6919 25.3996L11.4961 30.2947L11.4961 26.7012V24.7012H9.49609H8.49609C7.39152 24.7012 6.49609 23.8057 6.49609 22.7012V10.7012C6.49609 9.5966 7.39152 8.70117 8.49609 8.70117H24.4961C25.6007 8.70117 26.4961 9.5966 26.4961 10.7012V13.7012H28.4961V10.7012C28.4961 8.49203 26.7052 6.70117 24.4961 6.70117H8.49609C6.28695 6.70117 4.49609 8.49203 4.49609 10.7012V22.7012C4.49609 24.9103 6.28695 26.7012 8.49609 26.7012H9.49609V28.7012V30.2947C9.49609 32.1515 11.8062 33.006 13.0146 31.5962L17.2104 26.7012H19.4961V24.7012H17.2104Z",
  fill: "#AFAFAF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5411 33.0504L31.2417 32.7012H30.7818H23.4961C21.8392 32.7012 20.4961 31.358 20.4961 29.7012V17.7012C20.4961 16.0443 21.8392 14.7012 23.4961 14.7012H39.4961C41.1529 14.7012 42.4961 16.0443 42.4961 17.7012V29.7012C42.4961 31.358 41.1529 32.7012 39.4961 32.7012H38.4961H37.4961V33.7012V37.2947C37.4961 38.2231 36.341 38.6503 35.7368 37.9454L31.5411 33.0504Z",
  stroke: "#AFAFAF",
  strokeWidth: 2
});

var SvgMessageInactive = function SvgMessageInactive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageInactive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message-inactive.04ef8835.svg";
export { ForwardRef as ReactComponent };